export default __webpack_public_path__ + "static/media/sticker-K.ed3411e7.png";